import service from "./request";
import {
  baseURL,
  baseURL_PRO,
  baseURL_SEL,
  uploadUrl,
  pwdUrl
} from "./baseUrl.js";
const parseFormDataParams = data => {
  const formData = new FormData();
  for (const name in data) {
    if (data.hasOwnProperty(name)) {
      if (data[name]) {
        formData.append(name, data[name]);
      }
    }
  }
  return formData;
};
export const Api = {
  getJstkxxShjl: query => {
    return service({
      url: "/teacher/getJstkxxShjl",
      method: "post",
      baseURL,
      params: query
    });
  },
  workflowAuditingAll: query => {
    return service({
      url: "/examine/workflowAuditingAll",
      method: "post",
      baseURL,
      params: query
    });
  },
  fileDownload: query => {
    return service({
      url: "/xjInfo/fileDownload",
      method: "post",
      baseURL,
      responseType: "blob",
      params: query
    });
  },
  getXjydShList: query => {
    return service({
      url: "/examine/getXjydShList",
      method: "post",
      baseURL,
      params: query
    });
  },
  findXkztcx: query => {
    return service({
      url: "/teacher/findXkztcx",
      method: "post",
      baseURL,
      params: query
    });
  },
  findXkxsList: query => {
    return service({
      url: "/kaowu/findXkxsList",
      method: "post",
      baseURL,
      params: query
    });
  },
  findJxapglList: query => {
    return service({
      url: "/kaowu/findJxapglList",
      method: "post",
      baseURL,
      params: query
    });
  },
  gglyAdd: query => {
    return service({
      url: "/teacher/gglyAdd",
      method: "post",
      baseURL,
      params: query
    });
  },
  saveXsydsq: query => {
    return service({
      url: "/xjInfo/saveXsydsq",
      method: "post",
      baseURL,
      data: query
    });
  },
  findYdyy: query => {
    return service({
      url: "/xjInfo/findYdyy",
      method: "post",
      baseURL,
      params: query
    });
  },
  xjydsqInit: query => {
    return service({
      url: "/xjInfo/xjydsqInit",
      method: "post",
      baseURL,
      params: query
    });
  },
  xjydDetail: query => {
    return service({
      url: "/xjInfo/xjydDetail",
      method: "post",
      baseURL,
      params: query
    });
  },
  findXjydList: query => {
    return service({
      url: "/xjInfo/findXjydList",
      method: "post",
      baseURL,
      params: query
    });
  },
  xxwcqkOnkcxz: query => {
    return service({
      url: "/xjInfo/xxwcqkOnkcxz",
      method: "post",
      baseURL,
      params: query
    });
  },
  saveXjxx: query => {
    return service({
      url: "/xjInfo/saveXjxx",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  findStudentInfo: query => {
    return service({
      url: "/xjInfo/findStudentInfo",
      method: "post",
      baseURL,
      params: query
    });
  },
  jhrxxcj: query => {
    return service({
      url: "/student/jhrxxcj",
      method: "post",
      baseURL,
      params: query
    });
  },
  byxxhd: query => {
    return service({
      url: "/student/byxxhd",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  hksq_cancel: query => {
    return service({
      url: "/student/hksq_cancel",
      method: "post",
      baseURL,
      params: query
    });
  },
  fycjsq: query => {
    return service({
      url: "/student/fycjsq",
      method: "post",
      baseURL,
      params: query
    });
  },
  cjfh_list: query => {
    return service({
      url: "/student/cjfh_list",
      method: "post",
      baseURL,
      params: query
    });
  },
  query_ldrwshDetail: query => {
    return service({
      url: "/examine/query_ldrwshDetail",
      method: "post",
      baseURL,
      params: query
    });
  },
  query_ldrwshlist: query => {
    return service({
      url: "/examine/query_ldrwshlist",
      method: "post",
      baseURL,
      params: query
    });
  },
  getXsCjList: query => {
    return service({
      url: "/teacher/getXsCjList",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachingEvaluated: query => {
    return service({
      url: "/teacher/teachingEvaluated",
      method: "post",
      baseURL,
      params: query
    });
  },
  dsNoticeList: query => {
    return service({
      url: "/dsNoticeList",
      method: "post",
      baseURL,
      data: query
    });
  },
  saveTransfer_syk: query => {
    return service({
      url: "/teacher/saveTransfer_syk",
      method: "post",
      baseURL,
      data: query
    });
  },
  getkyjs_sy: query => {
    return service({
      url: "/teacher/getkyjs_sy",
      method: "post",
      baseURL,
      params: query
    });
  },
  getkysj_sy: query => {
    return service({
      url: "/teacher/getkysj_sy",
      method: "post",
      baseURL,
      params: query
    });
  },
  allyx: query => {
    return service({
      url: "/allyx",
      method: "post",
      baseURL,
      params: query
    });
  },
  jiaoskcbcx: query => {
    return service({
      url: "/teacher/jiaoskcbcx",
      method: "post",
      baseURL,
      params: query
    });
  },
  getlcShjl: query => {
    return service({
      url: "/examine/getlcShjl",
      method: "post",
      baseURL,
      params: query
    });
  },
  xsqjfjxz: query => {
    return service({
      url: "/student/xsqjfjxz",
      method: "post",
      baseURL,
      params: query
    });
  },
  xsxjsq_save: query => {
    return service({
      url: "/student/xsxjsq_save",
      method: "post",
      baseURL,
      params: query
    });
  },
  xsxjsq: query => {
    return service({
      url: "/student/xsxjsq",
      method: "post",
      baseURL,
      params: query
    });
  },
  xsqjsave: query => {
    return service({
      url: "/student/xsqjsave",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  xsqjadd: query => {
    return service({
      url: "/student/xsqjadd",
      method: "post",
      baseURL,
      params: query
    });
  },
  wdsq_list: query => {
    return service({
      url: "/student/wdsq_list",
      method: "post",
      baseURL,
      params: query
    });
  },
  getxssqjl: query => {
    return service({
      url: "/examine/getxssqjl",
      method: "post",
      baseURL,
      params: query
    });
  },
  savemtsh: query => {
    return service({
      url: "/teacher/savemtsh",
      method: "post",
      baseURL,
      params: query
    });
  },
  getmtshmx: query => {
    return service({
      url: "/teacher/getmtshmx",
      method: "post",
      baseURL,
      params: query
    });
  },
  savemtsq: query => {
    return service({
      url: "/student/savemtsq",
      method: "post",
      baseURL,
      params: query
    });
  },
  cxcjsq: query => {
    return service({
      url: "/student/cxcjsq",
      method: "post",
      baseURL,
      params: query
    });
  },
  mtsqCtxx: query => {
    return service({
      url: "/student/mtsqCtxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  cxmtsq: query => {
    return service({
      url: "/student/cxmtsq",
      method: "post",
      baseURL,
      params: query
    });
  },
  mtsqKcmx: query => {
    return service({
      url: "/student/mtsqKcmx",
      method: "post",
      baseURL,
      params: query
    });
  },
  cjcjShtj: query => {
    return service({
      url: "/student/cjcjShtj",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  cjsqxmcj: query => {
    return service({
      url: "/student/cjsqxmcj",
      method: "post",
      baseURL,
      params: query
    });
  },
  cjcjsqmx: query => {
    return service({
      url: "/student/cjcjsqmx",
      method: "post",
      baseURL,
      params: query
    });
  },
  getmtshlist: query => {
    return service({
      url: "/teacher/getmtshlist",
      method: "post",
      baseURL,
      params: query
    });
  },
  cjcjsqkc: query => {
    return service({
      url: "/student/cjcjsqkc",
      method: "post",
      baseURL,
      params: query
    });
  },
  mtsqKclist: query => {
    return service({
      url: "/student/mtsqKclist",
      method: "post",
      baseURL,
      params: query
    });
  },
  cjsqJl: query => {
    return service({
      url: "/student/cjsqJl",
      method: "post",
      baseURL,
      params: query
    });
  },
  saveCommonMenu: query => {
    return service({
      url: "/saveCommonMenu",
      method: "post",
      baseURL,
      params: query
    });
  },
  saveCommonMenu_10013: query => {
    return service({
      url: "/saveCommonMenu_10013",
      method: "post",
      baseURL,
      params: query
    });
  },
  delCommonMenu_10013: query => {
    return service({
      url: "/delCommonMenu_10013",
      method: "post",
      baseURL,
      params: query
    });
  },
  sxsxfjxz: query => {
    return service({
      url: "/student/sxsxfjxz",
      method: "post",
      baseURL,
      params: query
    });
  },
  sxdksave: query => {
    return service({
      url: "/student/sxdksave",
      method: "post",
      baseURL,
      params: query
    });
  },
  getsxkqmx1: query => {
    return service({
      url: "/student/getsxkqmx",
      method: "post",
      baseURL,
      params: query
    });
  },
  getsxkqdksj: query => {
    return service({
      url: "/student/getsxkqdksj",
      method: "post",
      baseURL,
      params: query
    });
  },
  getsxkqrwlist1: query => {
    return service({
      url: "/student/getsxkqrwlist",
      method: "post",
      baseURL,
      params: query
    });
  },
  getddsxsqlist: query => {
    return service({
      url: "/student/getddsxsqlist",
      method: "post",
      baseURL,
      params: query
    });
  },
  ddsxsqsave: query => {
    return service({
      url: "/student/ddsxsqsave",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  sxydsqsave: query => {
    return service({
      url: "/student/sxydsqsave",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  getsxydsqxx: query => {
    return service({
      url: "/student/getsxydsqxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  getsxydsqxmlist: query => {
    return service({
      url: "/student/getsxydsqxmlist",
      method: "post",
      baseURL,
      params: query
    });
  },
  getsxydsqjllist: query => {
    return service({
      url: "/student/getsxydsqjllist",
      method: "post",
      baseURL,
      params: query
    });
  },
  sxrwxspjsave: query => {
    return service({
      url: "/student/sxrwxspjsave",
      method: "post",
      baseURL,
      params: query
    });
  },
  getsxrwxspjlist: query => {
    return service({
      url: "/student/getsxrwxspjlist",
      method: "post",
      baseURL,
      params: query
    });
  },
  getsxkqmx: query => {
    return service({
      url: "/student/getsxkqmx",
      method: "post",
      baseURL,
      params: query
    });
  },
  getsxrwlist: query => {
    return service({
      url: "/student/getsxrwlist",
      method: "post",
      baseURL,
      params: query
    });
  },
  sxrwfbsave: query => {
    return service({
      url: "/teacher/sxrwfbsave",
      method: "post",
      baseURL,
      params: query
    });
  },
  getrwfbxx: query => {
    return service({
      url: "/teacher/getrwfbxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  sxrwJspjsave: query => {
    return service({
      url: "/teacher/sxrwJspjsave",
      method: "post",
      baseURL,
      params: query
    });
  },
  getrwfblist: query => {
    return service({
      url: "/teacher/getrwfblist",
      method: "post",
      baseURL,
      params: query
    });
  },
  getsxrwfbpjxslist: query => {
    return service({
      url: "/teacher/getsxrwfbpjxslist",
      method: "post",
      baseURL,
      params: query
    });
  },
  getsxrwxspjmx: query => {
    return service({
      url: "/teacher/getsxrwxspjmx",
      method: "post",
      baseURL,
      params: query
    });
  },
  getsxkqrwlist: query => {
    return service({
      url: "/teacher/getsxkqrwlist",
      method: "post",
      baseURL,
      params: query
    });
  },
  getsxkqxslist: query => {
    return service({
      url: "/teacher/getsxkqxslist",
      method: "post",
      baseURL,
      params: query
    });
  },
  getsxkqmx: query => {
    return service({
      url: "/teacher/getsxkqmx",
      method: "post",
      baseURL,
      params: query
    });
  },
  xspj_save: query => {
    return service({
      url: "/student/xspj_save",
      method: "post",
      baseURL,
      params: query
    });
  },
  xspj_edit: query => {
    return service({
      url: "/student/xspj_edit",
      method: "post",
      baseURL,
      params: query
    });
  },
  student_xspj_list: query => {
    return service({
      url: "/student/xspj_list",
      method: "post",
      baseURL,
      params: query
    });
  },
  xspj_find: query => {
    return service({
      url: "/student/xspj_find",
      method: "post",
      baseURL,
      params: query
    });
  },
  xspj_conf: query => {
    return service({
      url: "/teacher/xspj_conf",
      method: "post",
      baseURL,
      params: query
    });
  },
  xspj_list: query => {
    return service({
      url: "/teacher/xspj_list",
      method: "post",
      baseURL,
      params: query
    });
  },
  getVsbxq: query => {
    return service({
      url: "/sys/getVsbxq",
      method: "post",
      baseURL,
      params: query
    });
  },
  getVsbList: query => {
    return service({
      url: "/sys/getVsbList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getxsmd: query => {
    return service({
      url: "/teacher/getxsmd",
      method: "post",
      baseURL,
      params: query
    });
  },
  getjstzd: query => {
    return service({
      url: "/teacher/getjstzd",
      method: "post",
      baseURL,
      params: query
    });
  },
  savetksq: query => {
    return service({
      url: "/teacher/savetksq",
      method: "post",
      baseURL,
      params: query
    });
  },
  totksqadd: query => {
    return service({
      url: "/teacher/totksqadd",
      method: "post",
      baseURL,
      params: query
    });
  },
  gettkxxlist: query => {
    return service({
      url: "/teacher/gettkxxlist",
      method: "post",
      baseURL,
      params: query
    });
  },
  gettkxnxq: query => {
    return service({
      url: "/teacher/gettkxnxq",
      method: "post",
      baseURL,
      params: query
    });
  },
  jsjyglzdadd: query => {
    return service({
      url: "/teacher/jsjyglzdadd",
      method: "post",
      baseURL,
      params: query
    });
  },
  getjsjyglzd: query => {
    return service({
      url: "/teacher/getjsjyglzd",
      method: "post",
      baseURL,
      params: query
    });
  },
  getjsjygllist: query => {
    return service({
      url: "/teacher/getjsjygllist",
      method: "post",
      baseURL,
      params: query
    });
  },
  fxxywcqk: query => {
    return service({
      url: "/student/fxxywcqk",
      method: "post",
      baseURL,
      params: query
    });
  },
  zxxywcqk: query => {
    return service({
      url: "/student/zxxywcqk",
      method: "post",
      baseURL,
      params: query
    });
  },
  cxcxxf: query => {
    return service({
      url: "/student/cxcxxf",
      method: "post",
      baseURL,
      params: query
    });
  },
  getSelectApi: query => {
    return service({
      url: "/getSchoolUrL",
      method: "post",
      baseURL: baseURL_PRO,
      params: query
    });
  },
  getSystemFun: query => {
    return service({
      url: "/getSystemFun",
      method: "post",
      baseURL,
      params: query
    });
  },
  getHomeMenuApi: query => {
    return service({
      url: "/FindSch_Int",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  getHomeCommonMenuApi_10013: query => {
    return service({
      url: "/queryMobileCommonFunctions",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  getJspxpcApi_10013: query => {
    return service({
      url: "/jspx/jspxpc_find",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  getJspxkcApi_10013: query => {
    return service({
      url: "/jspx/jspxkc_list",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  getJspxkcEditApi_10013: query => {
    return service({
      url: "/jspx/jspxkc_edit",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  //评价提交
  saveJspxApi_10013: query => {
    return service({
      url: "/jspx/jspxkc_save",
      method: "post",
      baseURL,
      data: query
    });
  },
  getSubMenu: query => {
    return service({
      url: "/FindSch_Submenu",
      method: "post",
      baseURL: baseURL,
      params: query
    });
  },
  userLoginApi: query => {
    return service({
      url: "/login",
      method: "post",
      baseURL,
      params: query
    });
  },
  weChatBindLogin: query => {
    return service({
      url: "/weChatBind",
      method: "post",
      baseURL,
      params: query
    });
  },
  untiedWeChat: query => {
    return service({
      url: "/gzhUnbind",
      method: "post",
      baseURL,
      params: query
    });
  },
  thirdLoginBind: query => {
    return service({
      url: "/thirdLogin/bind",
      method: "post",
      baseURL,
      data: query
    });
  },
  toChooseTypeLogin: query => {
    return service({
      url: "/toChooseTypeLogin",
      method: "post",
      baseURL,
      params: query
    });
  },
  thirdLoginUnbind: query => {
    return service({
      url: "/thirdLogin/unBind",
      method: "post",
      baseURL,
      data: query
    });
  },
  authLoginApi: query => {
    return service({
      url: "/authUser",
      method: "post",
      baseURL,
      params: query
    });
  },
  /**
   * 绑定登录
   */
  bindLoginApi: query => {
    return service({
      url: "/authUser_bddl",
      method: "post",
      baseURL,
      params: query
    });
  },
  getSchoolCode: query => {
    return service({
      url: "/getSchoolCode",
      method: "post",
      baseURL,
      params: query
    });
  },
  getStuInfo: query => {
    return service({
      url: "/student/my",
      method: "post",
      baseURL,
      params: query
    });
  },
  wxpayGrade: query => {
    return service({
      url: "/wxPay/wxpayGrade",
      method: "post",
      baseURL,
      params: query
    });
  },
  getMessageMarkRead: query => {
    return service({
      url: "/messageMarkRead",
      method: "post",
      baseURL,
      params: query
    });
  },
  getNoticeList: query => {
    return service({
      url: "/noticeList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getAdvList: query => {
    return service({
      url: "/sys/getYfgggd",
      method: "post",
      baseURL,
      params: query
    });
  },
  getAdvItemList: query => {
    return service({
      url: "/sys/getYfggck",
      method: "post",
      params: query,
      baseURL
    });
  },
  getMyExamination: query => {
    return service({
      url: "/student/myExamination",
      method: "post",
      baseURL,
      params: query
    });
  },
  getGradeExamination: query => {
    return service({
      url: "/student/gradeExamination",
      method: "post",
      baseURL,
      params: query
    });
  },
  gradeExaminationSave: query => {
    return service({
      url: "/student/gradeExaminationSave",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  getTeaInfo: query => {
    return service({
      url: "/teacher/my",
      method: "post",
      baseURL,
      params: query
    });
  },
  getMsgApi: query => {
    return service({
      url: "/msgCenter",
      method: "post",
      baseURL,
      params: query
    });
  },
  getAnnualMajorList: query => {
    return service({
      url: "/annualMajorList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getEvaluateApi: query => {
    return service({
      url: "/student/studentEvaluate",
      method: "post",
      baseURL,
      params: query
    });
  },
  getEvaluateOnTimeApi: query => {
    return service({
      url: "/xspj/getEvaluateOnTimeDataList",
      method: "post",
      baseURL,
      params: query
    });
  },

  getEvaluateGoalApi: query => {
    return service({
      url: "/xspj/getEvaluateGloalDataList",
      method: "post",
      baseURL,
      params: query
    });
  },

  findEvaluatDate: query => {
    return service({
      url: "/xspj/findEvaluatGloalDate",
      method: "post",
      baseURL,
      params: query
    });
  },
  submitEvaluateGloal: query => {
    return service({
      url: "/xspj/pjGloalRecodeSave",
      method: "post",
      baseURL,
      params: query
    });
  },
  submitEvaluateZtpj: query => {
    return service({
      url: "/xspj/pjZtpjRecodeSave",
      method: "post",
      baseURL,
      params: query
    });
  },
  submitEvaluateSfpj: query => {
    return service({
      url: "/xspj/pjSfpjRecodeSave",
      method: "post",
      baseURL,
      data: query
    });
  },
  findZbList: query => {
    return service({
      url: "/xspj/findTeachingEvaluation_sfpj",
      method: "post",
      baseURL,
      params: query
    });
  },
  submitEvaluateKcpj: query => {
    return service({
      url: "/xspj/pjKcpjRecodeSave",
      method: "post",
      baseURL,
      data: query
    });
  },
  submitEvaluateOnTime: query => {
    return service({
      url: "/xspj/pjRecodeSave",
      method: "post",
      baseURL,
      params: query
    });
  },

  findMyEvaluateHistoryList: query => {
    return service({
      url: "/xspj/getMyEvaluateHistory",
      method: "post",
      baseURL,
      params: query
    });
  },

  getcounsellingteachingEvaluation: query => {
    return service({
      url: "/student/counsellingteachingEvaluation",
      method: "post",
      baseURL,
      params: query
    });
  },
  getCounsellingEvaluationIndex: query => {
    return service({
      url: "/student/counsellingevaluationIndex",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachEvaluation: query => {
    return service({
      url: "/student/teachingEvaluation",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachEvaluation_ztpj: query => {
    return service({
      url: "/xspj/teachingEvaluation_ztpj",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachingProgress: query => {
    return service({
      url: "/student/teachingProgress",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachTeachingProgress: query => {
    return service({
      url: "/teacher/teachingProgress",
      method: "post",
      baseURL,
      params: query
    });
  },
  examinationArrangement: query => {
    return service({
      url: "/student/examinationArrangement",
      method: "post",
      baseURL,
      params: query
    });
  },
  queryResit: query => {
    return service({
      url: "/student/queryResit",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTimeMode: query => {
    return service({
      url: "/Get_sjkbms",
      method: "post",
      baseURL,
      params: query
    });
  },
  getGgjxzlDate: query => {
    return service({
      url: "/getGgjxzlDate",
      method: "post",
      baseURL,
      params: query
    });
  },
  getNodeList: query => {
    return service({
      url: "/nodeLIst",
      method: "post",
      baseURL,
      params: query
    });
  },
  bigJcNode: query => {
    return service({
      url: "/bigJcNode",
      method: "post",
      baseURL,
      params: query
    });
  },
  getCampusList: query => {
    return service({
      url: "/campusList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTchBuildingList: query => {
    return service({
      url: "/tchBuildingList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getGnqList: query => {
    return service({
      url: "/getGnqList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getIdleClassroom: query => {
    return service({
      url: "/student/getIdleClassroom",
      method: "post",
      baseURL,
      params: query
    });
  },
  checkWorkAttendanceCal: query => {
    return service({
      url: "/checkWorkAttendance/calendar",
      method: "post",
      baseURL,
      params: query
    });
  },
  checkWorkAttendanceCourse: query => {
    return service({
      url: "/checkWorkAttendance/courseList",
      method: "post",
      baseURL,
      params: query
    });
  },
  checkWorkAttendanceStuCal: query => {
    return service({
      url: "/checkWorkAttendance/stu_calendar",
      method: "post",
      baseURL,
      params: query
    });
  },
  checkWorkAttendanceStuCourse: query => {
    return service({
      url: "/checkWorkAttendance/stu_courseList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachWeekCal: query => {
    return service({
      url: "/checkWorkAttendance/getJxzl",
      method: "post",
      baseURL,
      params: query
    });
  },
  checkWorkAttendanceSaveXskq: query => {
    return service({
      url: "/checkWorkAttendance/saveXskq",
      method: "post",
      baseURL,
      params: query
    });
  },
  checkWorkAttendanceGetKqxs: query => {
    return service({
      url: "/checkWorkAttendance/getKqxs",
      method: "post",
      baseURL,
      params: query
    });
  },
  checkWorkAttendanceZzdkqbj: query => {
    return service({
      url: "/checkWorkAttendance/zzdkqbj",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachGraduationProject: query => {
    return service({
      url: "/teacher/graduationProject",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachInvigilatorInquiry: query => {
    return service({
      url: "/teacher/invigilatorInquiry",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachInvigilatorInquiry_findStudent: query => {
    return service({
      url: "/teacher/teachInvigilatorInquiry_findStudent",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachChangeModeList: query => {
    return service({
      url: "/teacher/changeModeList",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachGetJsskxx: query => {
    return service({
      url: "/teacher/getJsskxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachGetJstkxx: query => {
    return service({
      url: "/teacher/getJstkxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachGetKxls: query => {
    return service({
      url: "/teacher/getKxls",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachingWeek: query => {
    return service({
      url: "/teachingWeek",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachingKkdw: query => {
    return service({
      url: "/teachingKkdw",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachingSkjs: query => {
    return service({
      url: "/teachingSkjs",
      method: "post",
      baseURL,
      params: query
    });
  },
  isYxMeetingV2Api: query => {
    return service({
      url: "/isYxMeetingV2",
      method: "post",
      baseURL,
      params: query
    });
  },
  stuCurriculum: query => {
    return service({
      url: "/student/curriculum",
      method: "post",
      baseURL,
      params: query
    });
  },
  selectReviewerApi: query => {
    return service({
      url: "/selectReviewer",
      method: "post",
      baseURL,
      params: query
    });
  },
  saveTransferApplication: query => {
    return service({
      url: "/teacher/saveTransferApplication",
      method: "post",
      baseURL,
      data: query
    });
  },
  getTeachGetkysj: query => {
    return service({
      url: "/teacher/getkysj",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachGetkyjs: query => {
    return service({
      url: "/teacher/getkyjs",
      method: "post",
      baseURL,
      params: query
    });
  },
  targetAndExplain: query => {
    return service({
      url: "/student/targetAndExplain",
      method: "post",
      baseURL,
      params: query
    });
  },
  guidanceTeaching: query => {
    return service({
      url: "/student/guidanceTeaching",
      method: "post",
      baseURL,
      params: query
    });
  },
  executionPlan: query => {
    return service({
      url: "/student/executionPlan",
      method: "post",
      baseURL,
      params: query
    });
  },
  //学生信息搜索111
  getXsxxList: query => {
    return service({
      url: "/teacher/getXsxxList",
      method: "post",
      baseURL,
      params: query
    });
  },
  //学籍状态
  getXsxjzt: query => {
    return service({
      url: "/teacher/getXsxjzt",
      method: "post",
      baseURL,
      params: query
    });
  },
  //学籍跳转
  getSosoXsxx: query => {
    return service({
      url: "/teacher/getSosoXsxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  //异动跳转
  getXjydHandleQuery: query => {
    return service({
      url: "/teacher/xjydHandleQuery",
      method: "post",
      baseURL,
      params: query
    });
  },
  //成绩跳转
  getXsxxckcj: query => {
    return service({
      url: "/teacher/tofindCj0708AllBycx",
      method: "post",
      baseURL,
      params: query
    });
  },
  //课表跳转
  getXskb: query => {
    return service({
      url: "/teacher/getXskb",
      method: "post",
      baseURL,
      params: query
    });
  },
  //创新学分跳转
  getCxxfcjQuery: query => {
    return service({
      url: "/teacher/cxxfcjQuery",
      method: "post",
      baseURL,
      params: query
    });
  },
  //学生考试信息跳转
  getQueryXsksap: query => {
    return service({
      url: "/teacher/queryXsksap",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 当前学年学期
  getCurrentTerm: query => {
    return service({
      url: "/currentTerm",
      method: "post",
      baseURL,
      params: query
    });
  },
  getStatueWaring: query => {
    return service({
      url: "/student/statueWaring",
      method: "post",
      baseURL,
      params: query
    });
  },
  getStatueAlienation: query => {
    return service({
      url: "/student/statueAlienation",
      method: "post",
      baseURL,
      params: query
    });
  },
  getWarningDetail: query => {
    return service({
      url: "/student/warningDetail",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachingMaterial: query => {
    return service({
      url: "/student/teachingMaterial",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachingMaterialTea: query => {
    return service({
      url: "/teacher/teachingMaterial",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachingCourse: query => {
    return service({
      url: "/student/teachingCourse",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachingCourseTea: query => {
    return service({
      url: "/teacher/teachingCourse",
      method: "post",
      baseURL,
      params: query
    });
  },
  getAlienationDetail: query => {
    return service({
      url: "/student/alinationDetail",
      method: "post",
      baseURL,
      params: query
    });
  },
  getSemesterList: query => {
    return service({
      url: "/semesterList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getKcxdmx: query => {
    return service({
      url: "/student/getKcxdmx",
      method: "post",
      baseURL,
      params: query
    });
  },
  getByjlck: query => {
    return service({
      url: "/student/getByjlck",
      method: "post",
      baseURL,
      params: query
    });
  },
  getCjpmXnxqList: query => {
    return service({
      url: "/cjpmXnxqList",
      method: "post",
      baseURL,
      params: query
    });
  },
  slowExaminationSave: query => {
    return service({
      url: "/student/slowExaminationSave",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  getTermGPA: query => {
    return service({
      url: "/student/termGPA",
      method: "post",
      baseURL,
      params: query
    });
  },
  getActivityName: query => {
    return service({
      url: "/student/activityName",
      method: "post",
      baseURL,
      params: query
    });
  },
  getSlowExamination: query => {
    return service({
      url: "/student/slowExamination",
      method: "post",
      baseURL,
      params: query
    });
  },
  getMySlowExamination: query => {
    return service({
      url: "/student/mySlowExamination",
      method: "post",
      baseURL,
      params: query
    });
  },
  getEvaluationIndex: query => {
    return service({
      url: "/student/evaluationIndex",
      method: "post",
      baseURL,
      params: query
    });
  },
  checkWorkAttendanceSaveXsqd: query => {
    return service({
      url: "/checkWorkAttendance/saveXsqd",
      method: "post",
      baseURL,
      params: query
    });
  },
  stuSaveEvaluate: query => {
    return service({
      url: "/student/saveEvaluate",
      method: "post",
      baseURL,
      data: query
    });
  },
  stucounsellingSaveEvaluate: query => {
    return service({
      url: "/student/counsellingsaveEvaluate",
      method: "post",
      baseURL,
      data: query
    });
  },
  socialTestScores: query => {
    return service({
      url: "/student/socialTestScores",
      method: "post",
      baseURL,
      params: query
    });
  },
  achievementRecognition: query => {
    return service({
      url: "/student/achievementRecognition",
      method: "post",
      baseURL,
      params: query
    });
  },
  getMyApply: query => {
    return service({
      url: "/student/myApply",
      method: "post",
      baseURL,
      params: query
    });
  },
  getMyApplyDetailed: query => {
    return service({
      url: "/student/myApplyDetailed",
      method: "post",
      baseURL,
      params: query
    });
  },
  submitCensorshipApi: query => {
    return service({
      url: "/submitCensorship",
      method: "post",
      baseURL,
      params: query
    });
  },
  alterNativeCourses: query => {
    return service({
      url: "/student/alternativeCourses",
      method: "post",
      baseURL,
      params: query
    });
  },
  alterNativeCoursesSave: query => {
    return service({
      url: "/student/alternativeCoursesSave",
      method: "post",
      baseURL,
      data: query
    });
  },
  /**
   * 选课
   */
  selectWxgetXsxktzsm: query => {
    return service({
      url: "/qzapp/wxgetXsxktzsm",
      method: "post",
      baseURL: baseURL_SEL,
      data: query
    });
  },
  selectWxxstkOper: query => {
    return service({
      url: "/qzapp/wxxstkOper",
      method: "post",
      baseURL: baseURL_SEL,
      data: query
    });
  },
  selectWxinitXscache: query => {
    return service({
      url: "/qzapp/wxinitXscache",
      method: "post",
      baseURL: baseURL_SEL,
      params: query
    });
  },
  selectWxgetXklc: query => {
    return service({
      url: "/qzapp/wxgetXklc",
      method: "post",
      baseURL: baseURL_SEL,
      data: query
    });
  },
  selectWxgetKcList: query => {
    return service({
      url: "/qzapp/wxgetKcList",
      method: "post",
      baseURL: baseURL_SEL,
      params: query
    });
  },
  selectWxxkOper: query => {
    return service({
      url: "/qzapp/wxxkOper",
      method: "post",
      baseURL: baseURL_SEL,
      params: query
    });
  },
  selectWxgetYxkcList: query => {
    return service({
      url: "/qzapp/wxgetYxkcList",
      method: "post",
      baseURL: baseURL_SEL,
      params: query
    });
  },
  /**
   * 教师端接口
   */
  teachGetCjcxByjs: query => {
    return service({
      url: "/teacher/getCjcxByjs",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachClassScoreList: query => {
    return service({
      url: "/teacher/classScoreList",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachGetCjxgxx: query => {
    return service({
      url: "/teacher/getCjxgxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  cjxgHisroty: query => {
    return service({
      url: "/teacher/cjxgHisroty",
      method: "get",
      baseURL,
      params: query
    });
  },
  teachCjxgSave: query => {
    return service({
      url: "/teacher/cjxgSave",
      method: "post",
      baseURL,
      data: query
    });
  },
  teachGetJstkxxDetail: query => {
    return service({
      url: "/teacher/getJstkxxDetail",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachCreatMeetingV2: query => {
    return service({
      url: "/teacher/creatMeetingV2",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachCourseSchedule: query => {
    return service({
      url: "/teacher/courseSchedule",
      method: "post",
      baseURL,
      params: query
    });
  },

  teachCourseSchedule_pra: query => {
    return service({
      url: "/teacher/courseSchedule_practice",
      method: "post",
      baseURL,
      params: query
    });
  },
  //班级课表
  classtimetable: query => {
    return service({
      url: "/classtimetable",
      method: "post",
      baseURL,
      params: query
    });
  },
  //全校课表
  classtimetableqx: query => {
    return service({
      url: "/classtimetableqx",
      method: "post",
      baseURL,
      params: query
    });
  },

  teachMyBorrowingClassrooms: query => {
    return service({
      url: "/teacher/myBorrowingClassrooms",
      method: "post",
      baseURL,
      params: query
    });
  },
  myBorrowingClassrooms: query => {
    return service({
      url: "/student/myBorrowingClassrooms",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachBorrowingClassrooms: query => {
    return service({
      url: "/teacher/borrowingClassrooms",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachSaveBorrowingClassrooms: query => {
    return service({
      url: "/teacher/saveborrowingClassrooms",
      method: "post",
      baseURL,
      data: query
    });
  },
  jsjysqUpload_13575: query => {
    return service({
      url: '/jsjysq/upload13575',
      method: 'post',
      baseURL,
      data: query,
    })
  },
  jsjysqUpload: query => {
    return service({
      url: "/jsjysq/upload",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  teachTeachingEvaluation: query => {
    return service({
      url: "/teacher/teachingEvaluation",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachTeachingEvaluationList: query => {
    return service({
      url: "/teacher/teachingEvaluationList",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 评教听课记录暂存
  savenotes: query => {
    return service({
      url: "/teacher/savenotes",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 评教上传附件
  jspjUpload: query => {
    return service({
      url: "/jspj/upload",
      method: "post",
      baseURL,
      // params: query
      data: query
    });
  },
  // 评教图片下载
  jspjDownfile: query => {
    return service({
      url: "/jspj/downfile",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachEvaluationIndex: query => {
    return service({
      url: "/teacher/evaluationIndex",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 提交评教
  teachSaveEvaluate: query => {
    return service({
      url: "/teacher/saveEvaluate",
      method: "post",
      baseURL,
      data: query
    });
  },
  // 删除评教
  deletePj: query => {
    return service({
      url: "/teacher/deletePj",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  getpjzf: query => {
    return service({
      url: "/teacher/getpjzf",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 保存教师自己设置的评价分数
  savepjzf: query => {
    return service({
      url: "/teacher/savepjzf",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 听课记录查询
  getnotes: query => {
    return service({
      url: "/teacher/getnotes",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 听课记录暂存
  getnotes: query => {
    return service({
      url: "/teacher/getnotes",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 评价上传图片
  upload: query => {
    return service({
      url: "/jspj/upload",
      method: "post",
      baseURL,
      params: parseFormDataParams(query)
    });
  },
  // 评价图片下载
  upload: query => {
    return service({
      url: "/jspj/downfile",
      method: "post",
      baseURL,
      responseType: "blob",
      params: query
    });
  },
  // 毕业状态查询
  getGraduationStatus: () => {
    return service({
      url: "/student/toFindBycjqr",
      method: "post",
      baseURL //baseURL:baseURL_PRO,
    });
  },
  // 重修查询
  getRelearn: () => {
    return service({
      url: "/student/getRelearn",
      method: "post",
      baseURL //baseURL:baseURL_PRO,
    });
  },
  getAcademicProgress: () => {
    return service({
      url: "/student/getAcademicProgress",
      method: "post",
      baseURL //baseURL:baseURL_PRO,
    });
  },
  // 学业进度
  getResit: query => {
    return service({
      url: "/student/getResit",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  // 补考报名
  weixinPayMsg: query => {
    return service({
      url: "/wxPay/weixinPayMsg",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  weixinPayInterface: query => {
    return service({
      url: "/wxPay/weixinPayInterface",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },

  getWeiXinPayStatus: query => {
    return service({
      url: "/wxPay/getWeiXinPayStatus",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },

  /**
   * 督学
   */
  supervisorGetxnxq: query => {
    return service({
      url: "/supervisor/getxnxq",
      method: "post",
      baseURL,
      params: query
    });
  },
  supervisorGettk01: query => {
    return service({
      url: "/supervisor/gettk01",
      method: "post",
      baseURL,
      params: query
    });
  },
  supervisorGettkpc: query => {
    return service({
      url: "/supervisor/gettkpc",
      method: "post",
      baseURL,
      params: query
    });
  },
  supervisorGetddkclist: query => {
    return service({
      url: "/supervisor/getddkclist",
      method: "post",
      baseURL,
      params: query
    });
  },
  supervisorGetddpjlist: query => {
    return service({
      url: "/supervisor/getddpjlist",
      method: "post",
      baseURL,
      params: query
    });
  },
  supervisorSavepjlist: query => {
    return service({
      url: "/supervisor/savepjlist",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachMajorFosterDetail: query => {
    return service({
      url: "/teacher/majorFosterDetail",
      method: "post",
      baseURL,
      params: query
    });
  },
  getGradeList: query => {
    return service({
      url: "/gradeList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getAcademyList: query => {
    return service({
      url: "/academyList",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachTeachingPlan: query => {
    return service({
      url: "/teacher/teachingPlan",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachFosterVertionList: query => {
    return service({
      url: "/teacher/fosterVertionList",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachFosterOutlineDetail: query => {
    return service({
      url: "/teacher/fosterOutlineDetail",
      method: "post",
      baseURL,
      params: query
    });
  },
  getClassList: query => {
    return service({
      url: "/classList",
      method: "post",
      baseURL,
      params: query
    });
  },
  teachTeachingProcess: query => {
    return service({
      url: "/teacher/teachingProcess",
      method: "post",
      baseURL,
      params: query
    });
  },
  getjyList: query => {
    return service({
      url: "/examine/getjy_list",
      method: "post",
      baseURL,
      params: query
    });
  },
  getjyCk: query => {
    return service({
      url: "/examine/getjy_ck",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTklist: query => {
    return service({
      url: "/examine/gettk_list",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTkck: query => {
    return service({
      url: "/examine/gettk_ck",
      method: "post",
      baseURL,
      params: query
    });
  },
  getcjMaxlr: query => {
    return service({
      url: "/examine/getcj_maxlr",
      method: "post",
      baseURL,
      params: query
    });
  },
  getcjFind: query => {
    return service({
      url: "/examine/getcj_find",
      method: "post",
      baseURL,
      params: query
    });
  },
  getcjCk: query => {
    return service({
      url: "/examine/getcj_ck",
      method: "post",
      baseURL,
      params: query
    });
  },
  downfile_13575: query => {
    return service({
      url: '/jsjy/downfile13575',
      method: 'post',
      baseURL,
      params: query,
    })
  },
  downfile: query => {
    return service({
      url: "/jsjy/downfile",
      method: "post",
      baseURL,
      responseType: "blob",
      params: query
    });
  },
  downfile_tk: query => {
    return service({
      url: "/tksq/downfile",
      method: "post",
      baseURL,
      responseType: "blob",
      params: query
    });
  },
  getshXx: query => {
    return service({
      url: "/examine/getsh_xx",
      method: "post",
      baseURL,
      params: query
    });
  },
  fileUpload: query => {
    return service({
      url: "/upload/fileUpload",
      method: "post",
      baseURL,
      data: query
    });
  },
  workflowAuditing: query => {
    return service({
      url: "/examine/workflowAuditing",
      method: "post",
      baseURL,
      params: query
    });
  },
  workflowAuditingNew: query => {
    return service({
      url: "/examine/jumpTobzb_njw",
      method: "post",
      baseURL,
      params: query
    });
  },
  getXqjd: query => {
    return service({
      url: "/getzzdzdb",
      method: "post",
      baseURL,
      params: query
    });
  },
  getJktd: query => {
    return service({
      url: "/kaowu/getjktd",
      method: "post",
      baseURL,
      params: query
    });
  },
  getJkjs: query => {
    return service({
      url: "/kaowu/getjk_js",
      method: "post",
      baseURL,
      params: query
    });
  },
  getkxjs: query => {
    return service({
      url: "/kaowu/queryTkJg0101",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTdshr: query => {
    return service({
      url: "/kaowu/user_select_ss",
      method: "post",
      baseURL,
      params: query
    });
  },
  cancelTdjs: query => {
    return service({
      url: "/kaowu/qxgoTdjg0101",
      method: "post",
      baseURL,
      params: query
    });
  },
  sstdjgSs: query => {
    return service({
      url: "/kaowu/sstdjg0101",
      method: "post",
      baseURL,
      params: query
    });
  },
  stkssqxx: query => {
    return service({
      url: "/kaowu/stkssqxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  getKszc: query => {
    return service({
      url: "/kaowu/get_kszc",
      method: "post",
      baseURL,
      params: query
    });
  },
  getXnxq: query => {
    return service({
      url: "/kaowu/get_xnxq",
      method: "post",
      baseURL,
      params: query
    });
  },
  getxqPjjgCk: query => {
    return service({
      url: "/teacher/getxqPjjgCk",
      method: "post",
      baseURL,
      params: query
    });
  },
  getSelectKsjs: query => {
    return service({
      url: "/kaowu/select",
      method: "post",
      baseURL,
      params: query
    });
  },
  getSelectKsls: query => {
    return service({
      url: "/kaowu/select_jg0101",
      method: "post",
      baseURL,
      params: query
    });
  },
  toSendSendStkssq: query => {
    return service({
      url: "/kaowu/toSendStkssq",
      method: "post",
      baseURL,
      params: query
    });
  },
  getLooksq: query => {
    return service({
      url: "/kaowu/stkssq_add",
      method: "post",
      baseURL,
      params: query
    });
  },
  getSjms: query => {
    return service({
      url: "/kaowu/Get_sjkbmsjc",
      method: "post",
      baseURL,
      params: query
    });
  },
  getQueryCriteria: query => {
    return service({
      url: "/teacher/get_queryCriteria",
      method: "get",
      baseURL,
      params: query
    });
  },
  getWorkloadList: query => {
    return service({
      url: "/teacher/workloadList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeaXfcpSemeter: query => {
    return service({
      url: "/teacher/xfcp_xnxq",
      method: "post",
      baseURL,
      params: query
    });
  },
  getRoomType: query => {
    return service({
      url: "/getzzdzdb",
      method: "post",
      baseURL,
      params: query
    });
  },
  getJyyt: () => {
    return service({
      url: "/getJyyt",
      method: "post",
      baseURL
    });
  },
  // 空闲教室
  todayClassrooms: query => {
    return service({
      url: "/todayClassrooms",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 待审核列表
  getNotShenHeMsg: query => {
    return service({
      url: "/examine/getNotShenHeMsg",
      method: "post",
      baseURL,
      params: query
    });
  },
  historyTask: query => {
    return service({
      url: "/examine/historyTask",
      method: "get",
      baseURL,
      params: query
    });
  },
  // 培养方案审核
  getCultivate: query => {
    return service({
      url: "/examine/getpyfa_list",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 新增课程审核
  getAddCourse: query => {
    return service({
      url: "/examine/getxzkc_list",
      method: "post",
      baseURL,
      params: query
    });
  },
  checkAddCourse: query => {
    return service({
      url: "/examine/getxzkc_ck",
      method: "post",
      baseURL,
      params: query
    });
  },
  getLearnStyleList: query => {
    return service({
      url: "/teacher/xfcp_list",
      method: "post",
      baseURL,
      params: query
    });
  },
  getLearnEvaData: query => {
    return service({
      url: "/teacher/xfcp_mx",
      method: "post",
      baseURL,
      params: query
    });
  },
  saveLearnStyle: query => {
    return service({
      url: "/teacher/xfcp_save",
      method: "post",
      baseURL,
      data: query
    });
  },
  addCourseAudit: query => {
    return service({
      url: "/examine/getszkk_list",
      method: "post",
      baseURL,
      data: query
    });
  },
  checkCourseOpen: query => {
    return service({
      url: "/examine/getszkk_ck",
      method: "post",
      baseURL,
      params: query
    });
  },
  checkGuide: query => {
    return service({
      url: "/examine/getpyfa_ck",
      method: "post",
      baseURL,
      params: query
    });
  },
  downloadFile: (query, fileName) => {
    // return service({
    //   url:'tysh/fjsc' + query,//upload/workflowFileDown
    //   method: 'post',
    //   // baseURL,
    //   // params: query,
    //   // responseType: 'arraybuffer'
    // })
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = baseURL + query;
    document.body.appendChild(elink);
    elink.click();
  },
  uploadApi: (query, id) => {
    return service({
      // url:'/jntcpy/savePhonetoByPhoto',
      url: "/kswjgl.do?method=savePhonetoByPhoto",
      method: "post",
      baseURL: uploadUrl,
      headers: id,
      data: parseFormDataParams(query)
    });
  },
  savePhonetoByPhoto: (query, id) => {
    return service({
      url: "/cjlr/savePhonetoByPhoto",
      method: "post",
      baseURL: uploadUrl,
      params: id,
      data: parseFormDataParams(query)
    });
  },
  uploadKscjApi: (query, id) => {
    return service({
      url: "/kscj/savemxfByPhoto",
      method: "post",
      baseURL: uploadUrl,
      headers: id,
      data: parseFormDataParams(query)
    });
  },
  uploadFileApi: (query, id) => {
    return service({
      url: "/xszhxxAction.do?method=savePhonetoByPhoto",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  uploadCjlrFileApi: (query, id) => {
    return service({
      url: "/cjlr/savePhonetoByPhoto",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  savePhotoFormPhone: (query, id) => {
    console.log(baseURL_SEL);
    return service({
      url: "/kbxx/savePhotoFormPhone",
      method: "post",
      baseURL_SEL,
      data: parseFormDataParams(query)
    });
  },
  changePassword: query => {
    return service({
      url: "/updatePassword",
      baseURL: pwdUrl,
      method: "post",
      data: query
    });
  },
  queryByStudentFuxiu: query => {
    return service({
      url: "/student/queryByStudentFuxiu",
      method: "post",
      baseURL,
      params: query
    });
  },
  showFxxsInfo: query => {
    return service({
      url: "/student/showFxxsInfo",
      method: "post",
      baseURL,
      params: query
    });
  },
  getResit_13104: query => {
    return service({
      url: "/student/getResit_13104",
      method: "post",
      baseURL,
      params: query
    });
  },
  bmResit_13104: query => {
    return service({
      url: "/student/bmResit_13104",
      method: "post",
      baseURL,
      params: query
    });
  },
  qxbmResit_13104: query => {
    return service({
      url: "/student/qxbmResit_13104",
      method: "post",
      baseURL,
      params: query
    });
  },
  fxbmOper: query => {
    return service({
      url: "/student/FxbmOper",
      method: "post",
      baseURL,
      params: query
    });
  },
  classcxtjList: query => {
    return service({
      url: "/classcxtjList",
      method: "post",
      baseURL,
      params: query
    });
  },
  qxFxbmOper: query => {
    return service({
      url: "/student/qxFxbmOper",
      method: "post",
      baseURL,
      params: query
    });
  },
  cxbmxk_query: query => {
    return service({
      url: "/student/cxbmxk_query",
      method: "post",
      baseURL,
      params: query
    });
  },
  cxbmxk_bm_save: query => {
    return service({
      url: "/student/cxbmxk_bm_save",
      method: "post",
      baseURL,
      params: query
    });
  },
  cxbmxk_getXkKc: query => {
    return service({
      url: "/student/cxbmxk_getXkKc",
      method: "post",
      baseURL,
      params: query
    });
  },
  cxbmxk_saveXkRuslt: query => {
    return service({
      url: "/student/cxbmxk_saveXkRuslt",
      method: "post",
      baseURL,
      params: query
    });
  },
  cxbmxk_getXkKcDeal: query => {
    return service({
      url: "/student/cxbmxk_getXkKcDeal",
      method: "post",
      baseURL,
      params: query
    });
  },
  exchangeQuery: query => {
    return service({
      url: "/teacher/courseSchedule",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 发送验证码
  sendVerifyCode: query => {
    return service({
      url: "/sys/getYzmfs",
      method: "post",
      baseURL,
      params: query
    });
  },
  getMobile: query => {
    return service({
      url: "/sys/mobile",
      method: "get",
      baseURL,
      params: query
    });
  },
  // 修改密码
  alterPassword: query => {
    return service({
      url: "/sys/getXgpwd",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 验证验证码
  checkVerifyCode: query => {
    return service({
      url: "/sys/yzmjy",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 获取自定义菜单
  getMenuAndPic: query => {
    return service({
      url: "/getPic",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 课堂教学反馈
  getJxfkxnxq: query => {
    return service({
      url: "/student/getJxfkxnxq",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 课堂教学反馈的课程
  getJxfkkc: query => {
    return service({
      url: "/student/getJxfkkc",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 课堂教学反馈的题目及答案
  getJxfktmda: query => {
    return service({
      url: "/student/getJxfktmda",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 课堂教学反馈信息保存
  xsjxfkSave: query => {
    return service({
      url: "/student/xsjxfkSave",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 获取uuid
  yktmk: query => {
    return service({
      url: "/patriarch/yktmk",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 获取成绩明细
  ScoreRanking: query => {
    return service({
      url: "/student/ScoreRanking",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 获取附加分
  additionalPoints: query => {
    return service({
      url: "/student/additionalPoints",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 考试安排查询
  ksapcx: query => {
    return service({
      url: "/teacher/ksapcx",
      method: "post",
      baseURL,
      params: query
    });
  },
  //考试安排查询-详细学生名单
  ksapxslist: query => {
    return service({
      url: "/teacher/ksap_xslist",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 教师端培养方案
  pyfalist: query => {
    return service({
      url: "/teacher/pyfalist",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 教师端培养方案
  pyfanrmx: query => {
    return service({
      url: "/teacher/pyfanrmx",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 教师端培养方案-学分要求
  pyfakctxxfyq: query => {
    return service({
      url: "/teacher/pyfakctxxfyq",
      method: "post",
      baseURL,
      params: query
    });
  },
  //学生过程评价
  getxsgcpjList: query => {
    return service({
      url: "/student/xsgcpjList",
      method: "get",
      baseURL,
      params: query
    });
  },
  //学生过程评价(评价分类)
  getpjflList: query => {
    return service({
      url: "/student/getpjflList",
      method: "get",
      baseURL,
      params: query
    });
  },
  //评价按钮
  getxsgcpjXq: query => {
    return service({
      url: "/student/xsgcpjXq",
      method: "get",
      baseURL,
      params: query
    });
  },
  //评价提交
  xsgcpjSave: query => {
    return service({
      url: "/student/xsgcpjSave",
      method: "post",
      baseURL,
      data: query
    });
  },
  //留言
  newxsly: query => {
    return service({
      url: "/student/newxsly",
      method: "post",
      baseURL,
      data: query
    });
  },
  //留言发送
  xslySave: query => {
    return service({
      url: "/student/xsly_save",
      method: "post",
      baseURL,
      data: query
    });
  },
  // 教师端培养方案-学分要求明细
  pyfakctxkcxx: query => {
    return service({
      url: "/teacher/pyfakctxkcxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  queryWord: query => {
    return service({
      url: query,
      baseURL,
      method: "get",
      responseType: "arrayBuffer"
    });
  },

  // 获取打卡统计

  //报道注册
  toRegistRationAction: query => {
    return service({
      url: "/student/toRegistRationAction",
      baseURL,
      method: "post",
      params: query
    });
  },
  //获取报道数据
  getRegistData: query => {
    return service({
      url: "/student/getRegistData",
      baseURL,
      method: "post",
      params: query
    });
  },
  getStudentByTD: query => {
    return service({
      url: "/kbxkrsList",
      method: "post",
      baseURL,
      params: query
    });
  },
  initJxkbcxData: query => {
    return service({
      url: "/teacher/initData_jxkbcx",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeacherCuMess: query => {
    return service({
      url: "/teacher/getTeacherCuMess",
      method: "post",
      baseURL,
      params: query
    });
  },
  getStudentAccount: query => {
    return service({
      url: "/student/getAccount",
      method: "post",
      baseURL,
      params: query
    });
  },
  getcaptchaCode: query => {
    return service({
      url: "/getVerifyImg",
      method: "post",
      baseURL,
      params: query
    });
  },
  getIsqdm: query => {
    return service({
      url: "/checkWorkAttendance/kqqdm",
      method: "post",
      baseURL,
      params: query
    });
  },
  initCurAllData: query => {
    return service({
      url: "/teacher/initData_curAll",
      method: "post",
      baseURL,
      params: query
    });
  },
  initKbData_time: query => {
    return service({
      url: "/teacher/initKbData_time",
      method: "post",
      baseURL,
      params: query
    });
  },
  getCurAllData: query => {
    return service({
      url: "/teacher/searchCurAllList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getBaseDataList: query => {
    return service({
      url: "/getBaseDataList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getStudentXjxx: query => {
    return service({
      url: "/student/xsXjxx_ck",
      method: "post",
      baseURL,
      params: query
    });
  },
  revokeJsjy: query => {
    return service({
      url: "/examine/jsjy_cs",
      method: "post",
      baseURL,
      params: query
    });
  },
  getXqlb: query => {
    return service({
      url: "/teacher/getXqlb",
      method: "post",
      baseURL,
      params: query
    });
  },
  getJsxklist: query => {
    return service({
      url: "/teacher/js_xkcx",
      method: "post",
      baseURL,
      params: query
    });
  },
  saveXspjYjtj: query => {
    return service({
      url: "/student/xspj_yjtj",
      method: "post",
      baseURL,
      params: query
    });
  },
  findDictionry: query => {
    return service({
      url: "/findDictionry",
      method: "post",
      baseURL,
      params: query
    });
  },
  getExemptExam: query => {
    return service({
      url: "/student/exemptExam",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  getKccjdkc: query => {
    return service({
      url: "/teacher/getKccjdkc",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  getKccjddownload: query => {
    return service({
      url: "/teacher/cjlr_import",
      method: "post",
      baseURL,
      responseType: "blob",
      params: query
    });
  },

  getSingMessData: query => {
    return service({
      url: "/checkWorkAttendance/getSingMessData",
      method: "post",
      baseURL,
      params: query
    });
  },
  getRetrievePwdData: query => {
    return service({
      url: "/retrievePwd",
      method: "post",
      baseURL,
      params: query
    });
  },
  getCjllcx: query => {
    return service({
      url: "/teacher/cjlucx",
      method: "post",
      baseURL,
      params: query
    });
  },
  updatePassword: query => {
    return service({
      url: "/updatePassword",
      baseURL,
      method: "post",
      data: query
    });
  },
  getJshkshList: query => {
    return service({
      url: "/teacher/getJshkshList",
      baseURL,
      method: "post",
      data: query
    });
  },
  hksqDownfile: query => {
    return service({
      url: "/hksq/downfile",
      method: "post",
      baseURL,
      params: query
    });
  },
  saveJsXshkSh: query => {
    return service({
      url: "/teacher/js_xshk_sh",
      method: "post",
      baseURL,
      params: query
    });
  },
  getZlpt: query => {
    return service({
      url: "/toZlpt",
      method: "post",
      baseURL,
      params: query
    });
  },
  delecjsq: query => {
    return service({
      url: "/student/delecjsq",
      method: "post",
      baseURL,
      params: query
    });
  },
  getAppkey: query => {
    return service({
      url: "/getAppkey",
      method: "post",
      baseURL,
      params: query
    });
  },
  loadZdmsg: query => {
    return service({
      url: "/gradDesign/getGuideMsg",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  loadMyDesignmsg: query => {
    return service({
      url: "/gradDesign/loadMyDesigKtMsg",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  loadMyDesignStudent: query => {
    return service({
      url: "/gradDesign/loadMyDesignStudent",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  loadByjbMsg: query => {
    return service({
      url: "/gradDesign/loadByjbMsg",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  loadZdmsgDeal: query => {
    return service({
      url: "/gradDesign/getGuideMsgDeal",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  saveGuidContext: query => {
    return service({
      url: "/gradDesign/saveGuidContext",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  saveIswfmes: query => {
    return service({
      url: "/gradDesign/saveIswfmes",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  loadMyDesignMsg: query => {
    return service({
      url: "/gradDesign/loadMyDesignMsg",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  loadMyDesignMsgDeal: query => {
    return service({
      url: "/gradDesign/loadMyDesignMsgDeal",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  saveIswfmes_add: query => {
    return service({
      url: "/gradDesign/saveIswfmes_add",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  distroyToken: query => {
    return service({
      url: "/distroyToken",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  distroySsoToken: query => {
    return service({
      url: "/distroySsoToken",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  getTeachKbMsg: query => {
    return service({
      url: "/teacher/getTeachKbMsg",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTeachKtMsg: query => {
    return service({
      url: "/JwyxAction/getTeacherKtMsg",
      method: "post",
      baseURL,
      params: query
    });
  },
  getxscjcxQuery: query => {
    return service({
      url: "/teacher/getxscjcx_query",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  getxscjcxList: query => {
    return service({
      url: "/teacher/getxscjcx_list",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  getpjjgQuery: query => {
    return service({
      url: "/teacher/getpjjg_query",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  getpjjgList: query => {
    return service({
      url: "/teacher/getpjjg_list",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  getdecoderUser: query => {
    return service({
      url: "/patriarch/decoderUser",
      method: "post",
      baseURL,
      params: query
    });
  },
  getZyjhDkxz: query => {
    return service({
      url: "/student/getZyjhDkxz",
      method: "post",
      baseURL,
      params: query
    });
  },
  getinitZyjhDk: query => {
    return service({
      url: "/student/getinitZyjhDk",
      method: "post",
      baseURL,
      params: query
    });
  },
  zyjhdkSave: query => {
    return service({
      url: "/student/zyjhdkSave",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  getZyjhDkxz_JS: query => {
    return service({
      url: "/teacher/getZyjhDkxz",
      method: "post",
      baseURL,
      params: query
    });
  },
  getinitZyjhDk_JS: query => {
    return service({
      url: "/teacher/getinitZyjhDk",
      method: "post",
      baseURL,
      params: query
    });
  },
  zyjhdkSave_JS: query => {
    return service({
      url: "/teacher/zyjhdkSave",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  getIsplttk: query => {
    return service({
      url: "/getIsplttk",
      method: "post",
      baseURL,
      params: query
    });
  },

  findMySkjh: query => {
    return service({
      url: "/JwyxAction/to_findMySkjh",
      method: "post",
      baseURL,
      params: query
    });
  },

  findSkjhByBzd: query => {
    return service({
      url: "/JwyxAction/getSkjhList",
      method: "post",
      baseURL,
      params: query
    });
  },
  findCauseSkjhMsg: query => {
    return service({
      url: "/JwyxAction/to_txskjhAct",
      method: "post",
      baseURL,
      params: query
    });
  },

  saveMyjxjh: query => {
    return service({
      url: "/JwyxAction/saveSkjhAct",
      method: "post",
      baseURL,
      params: query
    });
  },
  getJgxx: query => {
    return service({
      url: "/teacher/getjgxx",
      method: "post",
      baseURL,
      data: parseFormDataParams(query)
    });
  },
  findMyCuareEvalData: query => {
    return service({
      url: "/xspj/findMyCuareEvalData_teacher",
      method: "post",
      baseURL,
      params: query
    });
  },
  getEvaluateRecode_teacher: query => {
    return service({
      url: "/xspj/getEvaluateRecode_teacher",
      method: "post",
      baseURL,
      params: query
    });
  },
  //注册
  tosaveXszc: query => {
    return service({
      url: "/student/saveXszc",
      baseURL,
      method: "post",
      params: query
    });
  },
  //教材订购（选课结果）
  jcdgxkjgList: () => {
    return service({
      url: "/student/jcdgxkjgList",
      baseURL,
      method: "post"
    });
  },
  //教材订购（教材选择）
  xsxkXzjc: query => {
    return service({
      url: "/student/xsxkXzjc",
      baseURL,
      method: "post",
      params: query
    });
  },
  //保存教材
  saveXkjc: query => {
    return service({
      url: "/student/saveXkjc",
      baseURL,
      method: "post",
      params: query
    });
  },
  //退选所选教材
  delkjc: query => {
    return service({
      url: "/student/delkjc",
      baseURL,
      method: "post",
      params: query
    });
  },
  //承诺书同意保存
  cnsSava: query => {
    return service({
      url: "/student/cns_sava",
      baseURL,
      method: "post",
      params: query
    });
  },
  //查询缓考课程
  loadTytjData: query => {
    return service({
      url: "/student/loadTytjData",
      baseURL,
      method: "post",
      params: query
    });
  },
  yxkcTh: query => {
    return service({
      url: "/student/yxkcTh",
      method: "post",
      baseURL,
      params: query
    });
  },
  // 补考报名
  BkbmSave: query => {
    return service({
      url: "/student/BkbmSave",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  // 取消报名
  bkbmBmCancel: query => {
    return service({
      url: "/student/bkbmBmCancel",
      method: "post",
      baseURL, //baseURL:baseURL_PRO,
      params: query
    });
  },
  xspj_xsktpj(params) {
    return service({
      url: "/student/xspj_xsktpj",
      method: "post",
      baseURL,
      params: params
    });
  },
  xspj_xsktpj_save(params) {
    return service({
      url: "/student/xspj_xsktpj_save",
      method: "post",
      baseURL,
      data: parseFormDataParams(params)
    });
  },
  wpjssqshlist: query => {
    return service({
      url: "/teacher/wpjssqshlist",
      method: "post",
      baseURL,
      params: query
    });
  },
  wpjssqshjllist: query => {
    return service({
      url: "/teacher/wpjssqshjllist",
      method: "post",
      baseURL,
      params: query
    });
  },
  teacher_ktpjck(params) {
    return service({
      url: "/teacher/ktpjck",
      method: "post",
      baseURL,
      params: params
    });
  },
  workflowAuditingFile: query => {
    return service({
      url: "/examine/workflowAuditing",
      method: "post",
      baseURL,
      data: query
    });
  },
  stkssqshlist: data => {
    return service({
      url: "/teacher/stkssqshlist",
      method: "post",
      baseURL,
      params: data
    });
  },
  stkssqshjllist: data => {
    return service({
      url: "/teacher/stkssqshjllist",
      method: "post",
      baseURL,
      params: data
    });
  },
  getshjlxx: query => {
    return service({
      url: "/examine/getshjl_xx",
      method: "post",
      baseURL,
      params: query
    });
  },
  cjwtList: data => {
    return service({
      url: "/teacher/cjwtList",
      method: "post",
      baseURL,
      params: data
    });
  },
  getSfqyCjllr: query => {
    return service({
      url: "/student/getSfqyCjllr",
      method: "post",
      baseURL,
      params: query
    });
  },
  delCjrdApply: query => {
    return service({
      url: "/student/cjrd_del",
      method: "post",
      baseURL,
      params: query
    });
  },
  getCjlrsy: query => {
    return service({
      url: "/teacher/getCjlrsy",
      method: "post",
      baseURL,
      params: query
    });
  },
  getCjlrsyDetail: query => {
    return service({
      url: "/teacher/getCjlrsyDetail",
      method: "post",
      baseURL,
      params: query
    });
  },
  kxscjs: query => {
    return service({
      url: "/teacher/kxscjs",
      method: "post",
      baseURL,
      params: query
    });
  },
  findXX0301andNd: query => {
    return service({
      url: "/findXX0301andNd",
      method: "post",
      baseURL,
      params: query
    });
  },
  cxXkKc_query: (query) => {
    return service({
      url: '/cxXkAction/initCxCurList',
      method: 'post',
      baseURL,
      params: query,
    })
  },

  cxXkKc_saveBm: (query) => {
    return service({
      url: '/cxXkAction/saveBmResult',
      method: 'post',
      baseURL,
      params: query,
    })
  },

  cxXkKc_cancleBm: (query) => {
    return service({
      url: '/cxXkAction/cancelBmResult',
      method: 'post',
      baseURL,
      params: query,
    })
  },

  cxXkKc_queryKcList: (query) => {
    return service({
      url: '/cxXkAction/getCurListByCurNb',
      method: 'post',
      baseURL,
      params: query,
    })
  },
  saveXkResult: (query) => {
    return service({
      url: '/cxXkAction/saveXkResult',
      method: 'post',
      baseURL,
      params: query,
    })
  },
  doChaooseCur_cfbs: (query) => {
    return service({
      url: '/cxXkAction/getCurList_cfbs',
      method: 'post',
      baseURL,
      params: query,
    })
  },
  cxXkKc_cancleXk: (query) => {
    return service({
      url: '/cxXkAction/outXkResult',
      method: 'post',
      baseURL,
      params: query,
    })
  },
  cxXkKc_queryHistory: (query) => {
    return service({
      url: '/cxXkAction/getcxXkHistory',
      method: 'post',
      baseURL,
      params: query,
    })
  },
  gzlhdqr: (query) => {
    return service({
      url: "/teacher/gzlhdqr",
      method: "post",
      baseURL,
      params: query
    });
  },
  querySfgxshrApi: (query) => {
    return service({
      url: "/cxXkAction/querySfgxshrApi",
      method: "post",
      baseURL,
      params: query
    });
  },
  gocancel: query => {
    return service({
      url: "/cxXkAction/gocancel",
      method: "post",
      baseURL,
      params: query
    });
  },
  downloadHkpdf: (query) => {
    return service({
      url: '/cxXkAction/downloadHkpdf',
      method: 'post',
      baseURL,
      responseType: 'blob',
      params: query,
    });
  },
  teacherShxshk: (query) => {
    return service({
      url: "/student/teacherShxshk",
      method: "post",
      baseURL,
      params: query
    });
  },
  findXsxx: (query) => {
    return service({
      url: "/student/findXsxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  xshkshList: (query) => {
    return service({
      url: "/examine/xshkshList",
      method: "post",
      baseURL,
      params: query
    });
  },
  gethkCk: query => {
    return service({
      url: "/examine/gethk_ck",
      method: "post",
      baseURL,
      params: query
    });
  },
  cjrdshList: query => {
    return service({
      url: "/examine/cjrdshList",
      method: "post",
      baseURL,
      params: query
    });
  },
  pyfawcqktx: query => {
    return service({
      url: "/xjInfo/pyfawcqktx",
      method: "post",
      baseURL,
      params: query
    });
  },
  pyfawcqktxDetail: query => {
    return service({
      url: "/xjInfo/pyfawcqktxDetail",
      method: "post",
      baseURL,
      params: query
    });
  },
  doCxTkJl: (query) => {
    return service({
      url: '/teacherTkSq/doCxTkJl',
      method: 'post',
      baseURL,
      params: query,
    })
  },
  getSycurriculum: (query) => {
    return service({
      url: '/student/getSycurriculum',
      method: 'post',
      baseURL,
      params: query,
    })
  },
  //体测成绩查看
  stuendTccjList: query => {
    return service({
      url: "/student/stuendTccjList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTccjMxData: query => {
    return service({
      url: "/student/getTccjMxData",
      method: "post",
      baseURL,
      params: query
    });
  },
  getTccjcfMxData: query => {
    return service({
      url: "/student/getTccjcfMxData",
      method: "post",
      baseURL,
      params: query
    });
  },
  getyjtz: query => {
    return service({
      url: "/student/getyjtz",
      method: "post",
      baseURL,
      params: query
    });
  },
  getJx0415: query => {
    return service({
      url: "/student/getJx0415",
      method: "post",
      baseURL,
      params: query
    });
  },
  getBdxgkqshList: query => {
    return service({
      url: "/examine/bdxgkqshList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getStudentByReq: query => {
    return service({
      url: "/JwyxAction/getStudentByReq",
      method: "post",
      baseURL,
      params: query
    });
  },
  getWpjKc: query => {
    return service({
      url: "/xspj/getWpjKc",
      method: "post",
      baseURL,
      params: query
    });
  },
  getWdjxap: query => {
    return service({
      url: "/kaowu/findJsjxap",
      method: "post",
      baseURL,
      params: query
    });
  },
  getWdjxapDetail: query => {
    return service({
      url: "/kaowu/findJsjxapDetail",
      method: "post",
      baseURL,
      params: query
    });
  },
  findJsjkcx: query => {
    return service({
      url: "/kaowu/findJsjkcx",
      method: "post",
      baseURL,
      params: query
    });
  },
  findJsjkcxDetail: query => {
    return service({
      url: "/kaowu/findJsjkcxDetail",
      method: "post",
      baseURL,
      params: query
    });
  },
  findBybz: query => {
    return service({
      url: "/student/findBybzxf",
      method: "post",
      baseURL,
      params: query
    });
  },
  findBybz: query => {
    return service({
      url: "/student/findBybzxf",
      method: "post",
      baseURL,
      params: query
    });
  },
  findBybzxfXfDetail: query => {
    return service({
      url: "/student/findBybzxfXfDetail",
      method: "post",
      baseURL,
      params: query
    });
  },
  findKcksapcx: query => {
    return service({
      url: "/kaowu/findKcksapcx",
      method: "post",
      baseURL,
      params: query
    });
  },
  findKcksapcxDetail: query => {
    return service({
      url: "/kaowu/findKcksapcxDetail",
      method: "post",
      baseURL,
      params: query
    });
  },
  fileDownloadTkFj: query => {
    return service({
      url: "/kaowu/fileDownloadTkFj",
      method: "post",
      baseURL,
      responseType: "blob",
      params: query
    });
  },
  CxSfKclist: query => {
    return service({
      url: "/student/cxsfxk_kcList",
      method: "post",
      baseURL,
      params: query
    });
  },
  CxSfKcSave: query => {
    return service({
      url: "/student/cxbmxk_save",
      method: "post",
      baseURL,
      params: query
    });
  },
  findSyYyKc: query => {
    return service({
      url: "/sjsy/findSyYyKc",
      method: "post",
      baseURL,
      params: query
    });
  },
  findSyYyXm: query => {
    return service({
      url: "/sjsy/findSyYyXm",
      method: "post",
      baseURL,
      params: query
    });
  },
  syYyXxm: query => {
    return service({
      url: "/sjsy/syYyXxm",
      method: "post",
      baseURL,
      params: query
    });
  },
  syYyTx: query => {
    return service({
      url: "/sjsy/syYyTx",
      method: "post",
      baseURL,
      params: query
    });
  },
  findJsjbxx: query => {
    return service({
      url: "/jsInfo/findJsjbxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  jsjbxxEdit: query => {
    return service({
      url: "/jsInfo/jsjbxxEdit",
      method: "post",
      baseURL,
      params: query
    });
  },
  tokwapsqxx:query=>{
    return service({
      url: "/kaowu/tokwapsqxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  toksXz:query=>{
    return service({
      url: "/kaowu/toksxz",
      method: "post",
      baseURL,
      params: query
    });
  },
  getKsxq:query=>{
    return service({
      url: "/kaowu/getKsxq",
      method: "post",
      baseURL,
      params: query
    });
  },
  stkssqStks:query=>{
    return service({
      url: "/kaowu/stkssq_stks",
      method: "post",
      baseURL,
      params: query
    });
  },
  toKssqSave:query=>{
    return service({
      url: "/kaowu/toKssqSave",
      method: "post",
      baseURL,
      params: query
    });
  },
  toViewSjysxx:query=>{
    return service({
      url: "/kaowu/toViewSjysxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  toSaveSjysxx:query=>{
    return service({
      url: "/kaowu/toSaveSjysxx",
      method: "post",
      baseURL,
      params: query
    });
  },
  stkssqshList:query=>{
    return service({
      url: "/kaowu/stkssqsh_list",
      method: "post",
      baseURL,
      params: query
    });
  },
  toKssqEdit:query=>{
    return service({
      url: "/kaowu/toKssqEdit",
      method: "post",
      baseURL,
      params: query
    });
  },
  stksssCheck:query=>{
    return service({
      url: "/kaowu/stksss_check",
      method: "post",
      baseURL,
      params: query
    });
  },
  toKssqDel:query=>{
    return service({
      url: "/kaowu/toKssqDel",
      method: "post",
      baseURL,
      params: query
    });
  },
  toKssqShlc:query=>{
    return service({
      url: "/kaowu/toKssqShlc",
      method: "post",
      baseURL,
      params: query
    });
  },
  initSearchList:query=>{
    return service({
      url: "/jspx/init_searchCondition",
      method: "post",
      baseURL,
      params: query
    });
  },
  findMyTkJxcgData:query=>{
    return service({
      url: "/jspx/findMyTkJxcgData",
      method: "post",
      baseURL,
      params: query
    });
  },
  findMyTkData:query=>{
    return service({
      url: "/jspx/findMyTkMsg",
      method: "post",
      baseURL,
      params: query
    });
  },
  init_TkMsg:query=>{
    return service({
      url: "/jspx/init_TkMsg",
      method: "post",
      baseURL,
      params: query
    });
  },
  save_TkPj: query => {
    return service({
      url: "/jspx/saveTkPj",
      method: "post",
      baseURL,
      data: query
    });
  },
  del_TkYy: query => {
    return service({
      url: "/jspx/del_TkYy",
      method: "post",
      baseURL,
      params: query
    });
  },
  changeTklxList:query=>{
    return service({
      url: "/teacherTkSq/changeTklxList",
      method: "post",
      baseURL,
      params: query
    });
  },
  showTips:query=>{
    return service({
      url: "/teacherTkSq/showTips",
      method: "post",
      baseURL,
      params: query
    });
  },
  CancelGradeExamina: query => {
    return service({
      url: "/student/CancelGradeExamina",
      method: "post",
      baseURL,
      params: query
    });
  },
  findcxKqjlyl: query => {
    return service({
      url: "/checkWorkAttendance/findcxKqjlyl",
      method: "post",
      baseURL,
      params: query
    });
  },
  xspjJsmydpj: query => {
    return service({
      url: "/xspj/xspj_jsmydpj",
      method: "post",
      baseURL,
      params: query
    });
  },
  xspjYjtjWhhyzy: query => {
    return service({
      url: "/xspj/xspj_yjtj_whhyzy",
      method: "post",
      baseURL,
      params: query
    });
  },
  getXsxfjpmData: query => {
    return service({
      url: "/cjxx/getXsxfjpmData",
      method: "post",
      baseURL,
      params: query,
      timeout: 0
    });
  },

  checkWorkAttendanceZzdktjl: query => {
    return service({
      url: "/checkWorkAttendance/zzdktjl",
      method: "post",
      baseURL,
      params: query
    });
  },
  checkWorkAttendanceSaveKtjl: query => {
    return service({
      url: "/checkWorkAttendance/saveKtjl",
      method: "post",
      baseURL,
      params: query
    });
  },

  getxywcqkJs: query => {
    return service({
      url: "/xjInfo/getxywcqkJs",
      method: "post",
      baseURL,
      params: query
    });
  },
  getXkjsShDataList: query => {
    return service({
      url: "/examine/getXkjsShDataList",
      method: "post",
      baseURL,
      params: query
    });
  },
  getXkjsShXq: query => {
    return service({
      url: "/examine/getXkjsShXq",
      method: "post",
      baseURL,
      params: query
    });
  },
  getXnxq: query =>{
    return service({
      url:'/student/bkbm_xnxq',
      method:'post',
      baseURL,
      params: query
    })
  },
  getBkbmList:query =>{
    return service({
      url:'/student/bkbm_query',
      method:'post',
      baseURL,
      params: query
    })
  },
  getBkbmSave:query =>{
    return service({
      url:'/student/bkbm_bm_save',
      method:'post',
      baseURL,
      params: query
    })
  },
  getBkbmCancel:query =>{
    return service({
      url:'/student/bkbm_bm_cancel',
      method:'post',
      baseURL,
      params: query
    })
  },
  getCxbmXnxq: query =>{
    return service({
      url:'/student/cxbm_xnxq',
      method:'post',
      baseURL,
      params: query
    })
  },
  getCxbmList:query =>{
    return service({
      url:'/student/cxbm_query',
      method:'post',
      baseURL,
      params: query
    })
  },
  getCxbmSave:query =>{
    return service({
      url:'/student/cxbmxk_bm_save',
      method:'post',
      baseURL,
      params: query
    })
  },
  getCjdsqQuery:query =>{
    return service({
      url:'/student/cjdsq_query',
      method:'post',
      baseURL,
      params: query
    })
  },
  getCjdsqSave:query =>{
    return service({
      url:'/student/cjdsq_save',
      method:'post',
      baseURL,
      params: query
    })
  },
  cjdfileDownload: query => {
    return service({
      url: "/student/cjd_download",
      method: "post",
      baseURL,
      responseType: "blob",
      params: query
    });
  },
  getKsxxXnxq: query =>{
    return service({
      url:'/teacher/getxnxq',
      method:'post',
      baseURL,
      params: query
    })
  },
  getKsxxXqlb: query =>{
    return service({
      url:'/kaowu/get_xqlb',
      method:'post',
      baseURL,
      params: query
    })
  },
  getKsapcxQuery: query =>{
    return service({
      url:'/kaowu/getKsapcx',
      method:'post',
      baseURL,
      params: query
    })
  },
  cjdfileYl: query => {
    return service({
      url: "/student/cjd_yl",
      method: "post",
      baseURL,
      responseType: "blob",
      params: query
    });
  },
};



// WEBPACK FOOTER //
// ./src/utils/axios.js